import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
export function StudentActionsMenu({ status, onAction }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        function handleClick(e) {
            if (ref.current && !ref.current.contains(e.target))
                setOpen(false);
        }
        if (open)
            document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, [open]);
    const isApproved = status === 'approved';
    const items = [
        { key: 'edit', label: 'Editar datos' },
        { key: 'change-shift', label: 'Cambiar oposición / turno', hidden: isApproved },
        { key: 'change-status', label: 'Cambiar estado', hidden: isApproved },
        { key: 'create-payment', label: 'Crear pago manual', hidden: isApproved },
        { key: 'generate-enrollment', label: 'Generar matrícula', hidden: isApproved },
        { key: 'send-notification', label: 'Enviar notificación', hidden: isApproved },
        { key: 'reset-password', label: 'Resetear contraseña', hidden: isApproved },
        { key: 'close-sessions', label: 'Cerrar sesiones activas', hidden: isApproved },
        { key: 'delete', label: 'Eliminar alumno', danger: true },
    ];
    function handleClick(action) {
        setOpen(false);
        onAction(action);
    }
    return (_jsxs("div", { ref: ref, className: "relative", children: [_jsxs("button", { type: "button", onClick: () => setOpen((o) => !o), className: "inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700", "aria-haspopup": "menu", "aria-expanded": open, children: ["Acciones", _jsx("svg", { viewBox: "0 0 20 20", fill: "currentColor", className: "h-4 w-4", children: _jsx("path", { fillRule: "evenodd", d: "M5.23 7.21a.75.75 0 011.06.02L10 11.06l3.71-3.83a.75.75 0 111.08 1.04l-4.25 4.39a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z", clipRule: "evenodd" }) })] }), open && (_jsx("div", { role: "menu", className: "absolute right-0 z-30 mt-2 w-56 rounded-lg border border-gray-200 bg-white py-1 shadow-lg dark:border-gray-700 dark:bg-gray-900", children: items
                    .filter((it) => !it.hidden)
                    .map((it) => (_jsx("button", { type: "button", role: "menuitem", onClick: () => handleClick(it.key), className: `block w-full px-4 py-2 text-left text-sm transition-colors ${it.danger
                        ? 'text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-900/20'
                        : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800'}`, children: it.label }, it.key))) }))] }));
}
//# sourceMappingURL=StudentActionsMenu.js.map